import { Box, Button, Link, Typography } from "@mui/material";
import { InputController, RadioGroupController } from "../../../components/Controllers";
/* eslint-disable quote-props */
/* eslint-disable max-len */
import React, { FC, useEffect, useState } from "react";
import {
  ReasonForCancelFormType,
  ReasonForCancelSchema,
} from "../../../services/reason-for-cancel/reason-for-cancel.schema";

import { AlertCustom } from "../../../styles/styledComponents";
import GvSecondaryButton from "../../../components/GvSecondaryButton/GvSecondaryButton";
import { IOptionGeneric } from "../../interface";
import { LOCATIONS_URL } from "../../../config/params";
import { LoadingOverlay } from "../../../components";
import { CalendarXIcon, ShieldInfoIcon } from "../../../components/Icons";
import { useForm } from "react-hook-form";
import { useModal } from "../../../context/ModalContext";
import { useReasonForCancel } from "../../../services/reason-for-cancel/reason-for-cancel.service";
import { yupResolver } from "@hookform/resolvers/yup";

interface ChooseLocationFormProps {
  onSubmit: (data: ReasonForCancelFormType) => void;
  onReschedule: () => void,
  onLocation: () => void,
}

const VisitCancelForm: FC<ChooseLocationFormProps> = ({ onSubmit, onReschedule, onLocation }) => {
  const [options, setOptions] = useState<IOptionGeneric[]>([]);
  const [reasonSelected, setReasonSelected] = useState<ReasonForCancelFormType>();
  const { reasonForCancel, loading } = useReasonForCancel();
  const { control, handleSubmit, watch, setValue, formState: { isValid } } = useForm<ReasonForCancelFormType>({
    mode: "onChange",
    resolver: yupResolver(ReasonForCancelSchema),
    defaultValues: {
      reason: "",
      other: "",
    },
  });
  const { closeModal }=useModal();
  const handleDontCancel = () => {
    closeModal();
  };


  useEffect(() => {
    if (reasonForCancel) {
      const mapReasons: IOptionGeneric[] = reasonForCancel.items.map((item) => ({
        value: item.title,
        label: <>
          {reasonSelected?.reason === item.title ? (
            <>
              <Typography variant="body1" sx={{ fontWeight: "bold", hover: "cursor-pointer" }}>
                {item.title}
              </Typography>
              <Box sx={{ pb: 1, width: "100%", hover: "cursor-pointer" }}>
                <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
                  {item.description}
                </Typography>
                {item.type === "reschedule" ? (<Link className="!text-black !underline hover:cursor-pointer" onClick={onReschedule}>{item.typeDescription}</Link>) : null}
                {item.type === "location" ? (<Link className="!text-black !underline hover:cursor-pointer" href={LOCATIONS_URL} rel="noreferrer" target="_blank">{item.typeDescription}</Link>) : null}
                {item.type === "input" ? (
                  <InputController
                    control={control}
                    name="other"
                    label=""
                    placeholder="Type here"
                    multiline
                    rows={3}
                    sx={{
                      mb: 0, width: "110%", marginLeft: "-10%" }}
                  />
                ) : null}
              </Box>
            </>
          ) : <div className="hover:cursor-pointer">{item.title}</div>}
        </>,
      }));

      setOptions(mapReasons);
      setValue("other", "");
    }
  }, [reasonForCancel, reasonSelected]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "reason") {
        setReasonSelected(value as ReasonForCancelFormType);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  return <>
    <form onSubmit={handleSubmit(onSubmit)} className="h-full flex flex-col justify-between flex-1 overflow-y-auto pr-1 basis-0">
      <div className="">
        <div className="h-[10%]">
          <AlertCustom
            icon={<ShieldInfoIcon />}
            severity="info"
            sx={{ mb: 3, display: "none" }}
          >
            Note: There is a $50 fee for cancelling or rescheduling a visit within 48 hours of its originally scheduled time.
          </AlertCustom>

          <p className="geograph-regular font-semibold text-base pb-2 text-black pt-2">
            Reason for Cancellation:
          </p>
        </div>
        <div>
          {loading ? <LoadingOverlay /> : null}

          <RadioGroupController
            defaultChecked={false}
            control={control}
            name="reason"
            label=""
            options={options}
            variant="default"
            sxControl={{ minHeight: "40px", pb: 0.5, color: "#000000" }}
          />
        </div>
      </div>


      <div className="bg-gray-2 !sticky bottom-0">
        <Button
          fullWidth
          id="reasonForCancelFormSubmit"
          color="primary"
          type="submit"
          disabled={!isValid}
          className="!capitalize !font-bold"
          startIcon={<CalendarXIcon />}
        >
          Cancel visit
        </Button>
        <GvSecondaryButton
          type="submit"
          className="!capitalize !font-bold !text-black !hover:text:black"
          onClick={handleDontCancel}
        >
          Don&apos;t cancel
        </GvSecondaryButton>

      </div>


    </form>
  </>;
};

export default VisitCancelForm;
